import DateBadge from '../DateBadge';
import useTaskSubmitAction from '../hooks/useTaskSubmitAction';
import useKeepCurrentSalaryCta from '../hooks/useKeepCurrentSalaryCta';
import { Task, ACTIVE_TASK_STATUSES } from '../types';
import getTaskDisplay from '../utils/getTaskDisplay';
import priorityToDateBadgeIcon from '../utils/priorityToDateBadgeIcon';
import isOverdue from '../utils/isOverdue';
import TaskCardShell from '../common/TaskCardShell';

import MemberOperator, { useMemberOperatorTaskContext } from 'modules/common/components/MemberOperator';

interface TaskCardProps {
    task: Task;
    page?: string;
    // Injected by FeedItemTransition while this card plays its completion exit animation.
    isCompleting?: boolean;
}

function TaskCardContent({ task, page, isCompleting }: Readonly<TaskCardProps>) {
    const { onCtaClick, actionSurface } = useTaskSubmitAction(task);
    const secondaryCta = useKeepCurrentSalaryCta(task);
    const { sendTrackingEvent } = useMemberOperatorTaskContext();
    const { title, description, ctaLabel } = getTaskDisplay(task);
    const overdue = isOverdue(task.due_date);

    const handleCtaClick = () => {
        sendTrackingEvent('Task Viewed', { page });
        onCtaClick();
    };

    return (
        <>
            <TaskCardShell
                title={title}
                ctaLabel={ctaLabel}
                onCtaClick={handleCtaClick}
                secondaryCta={secondaryCta}
                dateBadge={<DateBadge date={task.due_date} icon={priorityToDateBadgeIcon(task.priority)} />}
                description={description}
                overdue={overdue}
                isCompleting={isCompleting}
            />
            {actionSurface}
        </>
    );
}

export default function TaskCard({ task, page, isCompleting }: Readonly<TaskCardProps>) {
    return (
        <MemberOperator task={task} trackViewOnMount={false} renderStatus={[...ACTIVE_TASK_STATUSES]}>
            <TaskCardContent task={task} page={page} isCompleting={isCompleting} />
        </MemberOperator>
    );
}
